import type { TanstackReactTable } from "@devhop/ui";
import { confirm, DataTable, toast } from "@devhop/ui";
import { TrashIcon } from "lucide-react";
import { RowActions } from "@/shared/ui/RowActions";
import { useDeleteChecklistKpiMapping } from "../api/queries";

export type ChecklistKpiMappingRow = {
  id: string;
  checklistId: string;
  kpiId: string;
  kpiName: string;
};

type ChecklistKpiMappingsTableProps = {
  checklistId: string;
  data: ChecklistKpiMappingRow[];
  isLoading?: boolean;
  onDeleted?: () => void;
};

export function ChecklistKpiMappingsTable({
  checklistId,
  data,
  isLoading,
  onDeleted,
}: ChecklistKpiMappingsTableProps) {
  const deleteMapping = useDeleteChecklistKpiMapping(checklistId);

  const columns: TanstackReactTable.ColumnDef<ChecklistKpiMappingRow>[] = [
    {
      id: "kpiName",
      header: "KPI",
      cell: ({ row }) => (
        <span className="font-medium text-sm">{row.original.kpiName}</span>
      ),
    },
    {
      id: "actions",
      header: "",
      cell: ({ row }) => (
        <RowActions
          actions={[
            {
              label: "ລຶບ",
              variant: "destructive",
              icon: <TrashIcon className="h-4 w-4" />,
              onClick: async () => {
                const ok = await confirm({
                  title: "ລຶບການຜູກ KPI",
                  description: "ທ່ານແນ່ໃຈບໍ່ວ່າຈະລຶບການດຶງຄ່າ KPI ນີ້ຈາກ checklist?",
                  actionText: "ລຶບ",
                  cancelText: "ຍົກເລີກ",
                  ActionProps: { variant: "destructive" },
                });
                if (!ok) return;
                try {
                  await deleteMapping.mutateAsync(row.original.id);
                  onDeleted?.();
                } catch {
                  toast.error("ລຶບບໍ່ສຳເລັດ");
                }
              },
            },
          ]}
        />
      ),
    },
  ];

  return (
    <div className="rounded-xl border bg-card">
      <DataTable<ChecklistKpiMappingRow, unknown>
        columns={columns}
        data={data}
        isLoading={isLoading}
        noDataMessage="ບໍ່ມີ KPI ທີ່ດຶງຄ່າຈາກ checklist ນີ້"
      />
    </div>
  );
}
